export const cases = [
  {
    id: "smart-city-brain",
    logo: "https://public.readdy.ai/ai/img_res/b51f1b85fd9744145e575b4328b9198f.jpg",
    title: "某市智慧城市大脑项目",
    tags: ["智慧城市", "AI平台"],
    metric: "10000+",
    metricLabel: "接入设备",
    image: "https://readdy.ai/api/search-image?query=Smart%20city%20command%20center%20with%20large%20display%20screens%20showing%20real-time%20urban%20data%20and%20traffic%20monitoring%20systems%20on%20modern%20clean%20background%2C%20representing%20intelligent%20city%20management%20platform&width=500&height=700&seq=case1&orientation=portrait",
    heroBg: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20smart%20city%20operations%20center%20with%20massive%20LED%20video%20wall%20displaying%20real%20time%20urban%20traffic%20flow%20maps%20environmental%20monitoring%20data%20and%20emergency%20response%20systems%2C%20professional%20command%20center%20with%20operators%20at%20workstations%2C%20representing%20intelligent%20city%20brain%20platform&width=1400&height=600&seq=case-hero1&orientation=landscape",
    client: "某地级市人民政府",
    industry: "智慧城市",
    projectDate: "2022年6月 - 2023年12月",
    overview: "该项目为地级市打造统一的城市大脑平台，整合交通、安防、环保、应急等12个委办局的数据资源，构建城市运行态势感知与智能决策中心。通过AI算法与大数据分析，实现城市事件的自动发现、智能研判与协同处置，显著提升城市治理效率与公共服务水平。",
    challenges: [
      {
        title: "数据孤岛问题",
        desc: "各委办局系统独立建设，数据标准不统一，难以实现跨部门数据共享与业务协同。",
        icon: "ri-database-2-line"
      },
      {
        title: "海量数据处理",
        desc: "每日产生超过50TB的城市运行数据，需要实时处理与分析，对计算能力与存储架构提出极高要求。",
        icon: "ri-speed-line"
      },
      {
        title: "复杂场景识别",
        desc: "城市治理涉及交通拥堵、违章停车、环境污染等数百种场景，需要高精度的AI识别与预警能力。",
        icon: "ri-eye-line"
      }
    ],
    solutions: [
      {
        title: "统一数据中台",
        desc: "构建城市级数据中台，制定统一数据标准，打通12个委办局的数据壁垒，实现数据的汇聚、治理与共享。",
        icon: "ri-database-line"
      },
      {
        title: "AI算法引擎",
        desc: "部署30+城市治理AI算法模型，覆盖交通优化、安防预警、环境监测等场景，识别准确率达95%以上。",
        icon: "ri-brain-line"
      },
      {
        title: "可视化指挥中心",
        desc: "建设城市运行指挥大厅，通过大屏实时展示城市运行态势，支持跨部门协同指挥与应急调度。",
        icon: "ri-dashboard-line"
      },
      {
        title: "云边协同架构",
        desc: "采用云边协同架构，边缘侧实时处理视频流，云端进行深度分析与决策，确保系统高效稳定运行。",
        icon: "ri-cloud-line"
      }
    ],
    results: [
      { label: "接入设备", value: "10,000+", unit: "台", icon: "ri-device-line" },
      { label: "日处理数据", value: "50+", unit: "TB", icon: "ri-hard-drive-line" },
      { label: "事件处置提速", value: "65", unit: "%", icon: "ri-time-line" },
      { label: "市民满意度提升", value: "30", unit: "%", icon: "ri-emotion-happy-line" }
    ],
    testimonial: {
      content: "龙创未来为我市打造的城市大脑平台，真正实现了城市治理的智能化与精细化。通过数据驱动决策，我们能够更快速地发现问题、解决问题，市民的获得感和满意度显著提升。",
      author: "某市政府领导",
      position: "分管副市长"
    }
  },
  {
    id: "manufacturing-ai",
    logo: "https://readdy.ai/api/search-image?query=Manufacturing%20company%20logo%20with%20industrial%20design%20elements%20on%20white%20background&width=200&height=80&seq=logo2&orientation=landscape",
    title: "大型制造企业工业AI平台",
    tags: ["工业数字化", "预测性维护"],
    metric: "35%",
    metricLabel: "效率提升",
    image: "https://readdy.ai/api/search-image?query=Advanced%20manufacturing%20facility%20with%20AI-powered%20quality%20inspection%20systems%20and%20digital%20production%20monitoring%20on%20clean%20industrial%20background%2C%20representing%20smart%20factory%20transformation&width=500&height=700&seq=case2&orientation=portrait",
    heroBg: "https://readdy.ai/api/search-image?query=Modern%20smart%20factory%20production%20floor%20with%20robotic%20assembly%20lines%20AI%20quality%20inspection%20cameras%20and%20digital%20twin%20visualization%20screens%20showing%20real%20time%20manufacturing%20data%2C%20clean%20high%20tech%20industrial%20environment%20representing%20Industry%204.0%20transformation&width=1400&height=600&seq=case-hero2&orientation=landscape",
    client: "某大型汽车零部件制造集团",
    industry: "先进制造",
    projectDate: "2021年9月 - 2023年3月",
    overview: "为大型汽车零部件制造集团实施全厂数字化转型，构建工业互联网平台与AI质检系统，实现从设备层到管理层的全方位智能化升级。通过数字孪生、预测性维护、AI质检等技术应用，显著提升生产效率、降低运营成本、提高产品质量。",
    challenges: [
      {
        title: "设备老旧异构",
        desc: "工厂拥有不同年代、不同品牌的生产设备200+台，通信协议各异，数据采集难度大。",
        icon: "ri-tools-line"
      },
      {
        title: "质检效率低下",
        desc: "传统人工目检方式效率低、漏检率高，无法满足高精度零部件的质量要求。",
        icon: "ri-search-eye-line"
      },
      {
        title: "设备故障频发",
        desc: "关键设备故障导致产线停机，缺乏有效的预测性维护手段，维修成本高昂。",
        icon: "ri-alarm-warning-line"
      }
    ],
    solutions: [
      {
        title: "工业互联网平台",
        desc: "部署自研工业互联网平台，支持20+种工业协议，实现200+台异构设备的统一接入与数据采集。",
        icon: "ri-global-line"
      },
      {
        title: "AI视觉质检系统",
        desc: "在关键工序部署AI视觉质检设备，替代人工目检，实现产品缺陷的自动识别与分类，检测速度提升10倍。",
        icon: "ri-eye-line"
      },
      {
        title: "预测性维护",
        desc: "基于设备运行数据与机器学习算法，建立设备健康度模型，提前预警潜在故障，降低非计划停机。",
        icon: "ri-heart-pulse-line"
      },
      {
        title: "数字孪生产线",
        desc: "构建产线级数字孪生模型，实时映射物理产线状态，支持生产仿真优化与远程监控。",
        icon: "ri-3d-cube-sphere-line"
      }
    ],
    results: [
      { label: "生产效率提升", value: "40", unit: "%", icon: "ri-speed-up-line" },
      { label: "不良品率降低", value: "60", unit: "%", icon: "ri-arrow-down-line" },
      { label: "设备故障减少", value: "50", unit: "%", icon: "ri-tools-fill" },
      { label: "运营成本节省", value: "25", unit: "%", icon: "ri-money-dollar-circle-line" }
    ],
    testimonial: {
      content: "龙创未来的工业AI解决方案帮助我们实现了从传统制造到智能制造的跨越。AI质检系统不仅提升了检测效率，更重要的是大幅降低了不良品率，为我们赢得了更多客户信任。",
      author: "某制造集团",
      position: "生产总监"
    }
  },
  {
    id: "hospital-ai-diagnosis",
    logo: "https://readdy.ai/api/search-image?query=Hospital%20medical%20institution%20logo%20with%20healthcare%20symbol%20on%20white%20background&width=200&height=80&seq=logo3&orientation=landscape",
    title: "三甲医院AI辅助诊断系统",
    tags: ["AI医疗", "影像分析"],
    metric: "95%",
    metricLabel: "诊断准确率",
    image: "https://readdy.ai/api/search-image?query=Modern%20hospital%20AI%20diagnostic%20room%20with%20medical%20imaging%20displays%20and%20intelligent%20analysis%20systems%20on%20clean%20healthcare%20background%2C%20representing%20advanced%20medical%20technology&width=500&height=700&seq=case3&orientation=portrait",
    heroBg: "https://readdy.ai/api/search-image?query=Advanced%20hospital%20radiology%20department%20with%20AI-powered%20medical%20imaging%20workstations%20displaying%20CT%20and%20MRI%20scans%20with%20intelligent%20diagnostic%20annotations%2C%20clean%20modern%20healthcare%20environment%20with%20medical%20professionals%20reviewing%20AI%20analysis%20results&width=1400&height=600&seq=case-hero3&orientation=landscape",
    client: "某省级三甲综合医院",
    industry: "医疗健康",
    projectDate: "2022年3月 - 2023年6月",
    overview: "为省级三甲医院影像科部署AI辅助诊断系统，覆盖CT、MRI、X光等多种影像类型，支持肺结节、骨折、脑卒中等30+种疾病的智能识别与辅助诊断。系统与医院PACS无缝集成，显著提升影像诊断效率与准确率，减轻医生工作负担。",
    challenges: [
      {
        title: "影像数据量大",
        desc: "医院每日产生5000+份影像检查，医生阅片工作量巨大，容易出现疲劳误诊。",
        icon: "ri-file-list-3-line"
      },
      {
        title: "诊断标准不一",
        desc: "不同医生的诊断经验与标准存在差异，影响诊断一致性与准确性。",
        icon: "ri-user-line"
      },
      {
        title: "系统集成复杂",
        desc: "需要与医院现有PACS、HIS等多个系统对接，确保数据安全与业务流程顺畅。",
        icon: "ri-links-line"
      }
    ],
    solutions: [
      {
        title: "多模态AI算法",
        desc: "部署30+种疾病的AI识别算法，支持CT、MRI、X光等多种影像类型，诊断准确率达95%以上。",
        icon: "ri-brain-line"
      },
      {
        title: "智能辅助标注",
        desc: "AI自动识别病灶区域并进行标注，生成结构化诊断报告，医生只需审核确认，阅片效率提升3倍。",
        icon: "ri-edit-box-line"
      },
      {
        title: "无缝系统集成",
        desc: "与医院PACS系统深度集成，影像自动推送至AI系统分析，结果回传至医生工作站，无需改变现有工作流程。",
        icon: "ri-plug-line"
      },
      {
        title: "数据安全保障",
        desc: "符合医疗数据安全规范，支持本地化部署，患者隐私数据不出院区，通过三级等保认证。",
        icon: "ri-shield-check-line"
      }
    ],
    results: [
      { label: "诊断准确率", value: "95", unit: "%", icon: "ri-check-double-line" },
      { label: "阅片效率提升", value: "3", unit: "倍", icon: "ri-speed-up-line" },
      { label: "日处理影像", value: "5,000+", unit: "份", icon: "ri-file-line" },
      { label: "医生满意度", value: "92", unit: "%", icon: "ri-emotion-happy-line" }
    ],
    testimonial: {
      content: "AI辅助诊断系统极大地提升了我们的工作效率，特别是在肺结节筛查方面，AI能够快速定位可疑病灶，让我们能够将更多精力放在疑难病例的分析上，真正实现了人机协同。",
      author: "某三甲医院",
      position: "影像科主任"
    }
  },
  {
    id: "smart-agriculture",
    logo: "https://readdy.ai/api/search-image?query=Agricultural%20technology%20company%20logo%20with%20modern%20farming%20elements%20on%20white%20background&width=200&height=80&seq=logo4&orientation=landscape",
    title: "智慧农业监测平台",
    tags: ["智慧农业", "物联网"],
    metric: "20%",
    metricLabel: "产量增长",
    image: "https://readdy.ai/api/search-image?query=High-tech%20greenhouse%20with%20IoT%20sensors%20and%20automated%20crop%20monitoring%20systems%20on%20clean%20agricultural%20background%2C%20representing%20precision%20farming%20technology&width=500&height=700&seq=case4&orientation=portrait",
    heroBg: "https://readdy.ai/api/search-image?query=Modern%20smart%20greenhouse%20interior%20with%20automated%20irrigation%20systems%20IoT%20environmental%20sensors%20and%20crop%20monitoring%20cameras%2C%20lush%20healthy%20plants%20growing%20under%20controlled%20conditions%20with%20digital%20monitoring%20displays%2C%20representing%20precision%20agriculture%20technology&width=1400&height=600&seq=case-hero4&orientation=landscape",
    client: "某大型农业科技园区",
    industry: "现代农业",
    projectDate: "2022年1月 - 2022年12月",
    overview: "为大型农业科技园区打造智慧农业监测平台，通过物联网传感器、AI图像识别与大数据分析技术，实现温室环境的精准监测与智能调控、作物生长的实时监测与病虫害预警，显著提升农业生产效率与产品品质。",
    challenges: [
      {
        title: "环境监测盲区",
        desc: "传统人工巡检方式无法实时掌握温室内温湿度、光照、CO2等环境参数变化。",
        icon: "ri-temp-hot-line"
      },
      {
        title: "病虫害防治滞后",
        desc: "病虫害发现不及时，往往造成大面积损失，缺乏有效的早期预警手段。",
        icon: "ri-bug-line"
      },
      {
        title: "灌溉施肥粗放",
        desc: "传统经验式管理方式，水肥利用率低，难以实现精准化、科学化种植。",
        icon: "ri-drop-line"
      }
    ],
    solutions: [
      {
        title: "物联网监测网络",
        desc: "部署500+个环境传感器，实时采集温湿度、光照、土壤等数据，构建全方位环境监测网络。",
        icon: "ri-sensor-line"
      },
      {
        title: "AI病虫害识别",
        desc: "通过图像识别技术，自动识别作物叶片病害与虫害，准确率达90%以上，实现早发现早防治。",
        icon: "ri-eye-line"
      },
      {
        title: "智能水肥一体化",
        desc: "根据作物生长阶段与环境数据，AI自动计算最优灌溉施肥方案，实现精准化管理。",
        icon: "ri-water-flash-line"
      },
      {
        title: "可视化管理平台",
        desc: "PC端与移动端统一管理平台,实时查看园区运行状态，远程控制温室设备，随时随地掌握生产动态。",
        icon: "ri-dashboard-line"
      }
    ],
    results: [
      { label: "产量增长", value: "20", unit: "%", icon: "ri-arrow-up-line" },
      { label: "水肥节约", value: "30", unit: "%", icon: "ri-drop-line" },
      { label: "病虫害损失降低", value: "50", unit: "%", icon: "ri-shield-check-line" },
      { label: "人工成本节省", value: "40", unit: "%", icon: "ri-money-dollar-circle-line" }
    ],
    testimonial: {
      content: "智慧农业平台让我们的种植管理从经验驱动转变为数据驱动。通过精准的环境调控和及时的病虫害预警，不仅产量提升了，产品品质也更加稳定，市场竞争力显著增强。",
      author: "某农业科技园区",
      position: "总经理"
    }
  }
];
